import i18next from './LocalizedStrings';
// import { getFlagImage } from '../object/Country'

const langs = ['en', 'ja', 'ko']

export const companyInfo = {

    getName: function () {

        const lang = i18next.getLanguage()

        if (this.name[lang] == undefined) {
            return this.name.en
        }

        return this.name[lang]

        // if (i18next.getLanguage() === 'ko') {
        //     return this.title_ko
        // } else if (i18next.getLanguage() === 'jp') {
        //     return this.title_ja
        // } else {
        //     return this.title_en
        // }
    },

    getUSName: function () {

        let nativeName;
        if (this.country_code === 'KR') {
            nativeName = this.name.ko
        } else if (this.country_code === 'JP') {
            nativeName = this.name.ja
        } else if (this.country_code === 'US') {
            nativeName = this.name.en
        }

        if (this.getName() === nativeName) {
            if (this.title_en) {
                return this.title_en
            }
            return ""
        }

        return nativeName
    },

    getExchange: function () {

        const lang = i18next.getLanguage()
        if (this.exchange[lang] == undefined) {
            return this.exchange.en
        }

        return this.exchange[lang]
    },

    getSection: function () {
        const lang = i18next.getLanguage()
        if (this.sector[lang] == undefined) {
            return this.sector.en
        }

        return this.sector[lang]
    },

    getIndustry: function () {
        const lang = i18next.getLanguage()
        if (this.industry[lang] == undefined) {
            return this.industry.en
        }

        return this.industry[lang]
    },

    // getFlagImage: function () {
    //     return getFlagImage(this.country)
    // },

    isHaveSection: function () {
        if (this.section) {
            return true
        }

        return false
    },

    isHaveIndustry: function () {
        if (this.industry) {
            return true
        }

        return false
    },

    getWikiInfoBox: function (lang) {

        return this.wiki ? this.wiki['info_box_' + lang] || this.wiki['info_box_en'] : undefined
    },

    getWikiSummary: function () {

        if (this.wiki == undefined || this.tableData.length == 1) {
            return ''
        }

        if (i18next.getLanguage() == 'ko') {
            return (this.wiki.summary_ko || this.wiki.summary_en) || this.wiki.summary_ja
        } else if (i18next.getLanguage() == 'ja') {
            return (this.wiki.summary_ja || this.wiki.summary_en) || this.wiki.summary_ko
        } else {
            return (this.wiki.summary_en || this.wiki.summary_ja) || this.wiki.summary_ko
        }
    },

    getInfoBoxValueFromInfoBoxArray: function (infoBoxes, key) {
        let value = undefined

        for (var i = 0; i < infoBoxes.length; i++) {
            const infoBox = infoBoxes[i]
            if (infoBox[key]) {
                value = infoBox[key]
                break
            }

        }

        return value
    },

    getLangsOrder: function () {
        const langsOrder = [i18next.getLanguage(), 'en']

        if (this.country == 'KOR') {
            langsOrder.push('ko')
        } else if (this.country == 'JPN') {
            langsOrder.push('ja')
        }

        for (var i = 0; i < langs.length; i++) {
            const lang = langs[i]
            if (!langsOrder.includes(lang)) {
                langsOrder.push(lang)
            }
        }

        return langsOrder
    },

    getInfoBoxList: function () {
        const langsOrder = this.getLangsOrder()
        const infoBoxes = []

        if (this.wiki == undefined) return []

        for (var i = 0; i < langsOrder.length; i++) {
            const infoBox = this.wiki['info_box_' + langsOrder[i]]
            if (infoBox) {
                infoBoxes.push(infoBox)
            }
        }

        return infoBoxes
    },

    setTableData: function () {

        const infoBoxes = this.getInfoBoxList()
        const tableData = [
            { exchange: this['exchange_' + i18next.getLanguage()] },
            { hq_location: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'hq_location') },
            { owner: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'owner') },
            { founded: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'founded') },
            { products: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'products') },
            { brands: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'brands') },
            { key_people: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'key_people') },
            { assets: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'assets') },
            { equity: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'equity') },
            { revenue: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'revenue') },
            { operating_income: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'operating_income') },
            { profit: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'profit') },
            { num_employees: this.getInfoBoxValueFromInfoBoxArray(infoBoxes, 'num_employees') },
        ]

        this.tableData = []

        for (const idx in tableData) {
            const data = tableData[idx]
            if (data[Object.keys(data)[0]] != undefined) {
                this.tableData.push(data)
            }
        }
    },

    getThumbImage: function () {
        if (this.wiki == undefined) return undefined
        const infoBoxes = this.getInfoBoxList()

        for (const idx in infoBoxes) {
            const infoBox = infoBoxes[idx]
            if (infoBox['thumbnail']) {
                return infoBox['thumbnail']['source']
            }
        }

        return undefined
    }
}